// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SideMenuLanguage{
    max-width: 100%;
    max-height: 100%;
}

.SideMenuLanguage_select{
    display: flex;
    gap: 14px;
}`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/components/sideMenu/SideMenuLanguage.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;AACb","sourcesContent":[".SideMenuLanguage{\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.SideMenuLanguage_select{\n    display: flex;\n    gap: 14px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
